import { Pipe, PipeTransform } from '@angular/core';
import { PassengerPrice } from '@univacity/shared/types';

@Pipe({
  name: 'fromPrice',
  standalone: false,
})
export class FromPricePipe implements PipeTransform {
  transform(pricing: PassengerPrice): number {
    let lowest = pricing.student;
    for (const p of Object.values(pricing)) {
      if (typeof p === 'number' && p < lowest && p > 0) lowest = p;
    }
    return lowest;
  }
}
